// src/graphql/department.js
import { gql } from '@apollo/client/core'  

const summaryReturnedFields = `
        name
        path
        _id
        isActive
        company{ 
          _id
          path
          name
          isActive
        }
        organisation{ 
          _id
          path
          name
          isActive
        }
`

/**
 * SUMMARY QUERY
 * Fetches lightweight info for list view
 */
export const SUMMARY_QUERY = gql`
  query DepartmentSummary {
    items: departmentsByFields {
      ${summaryReturnedFields}
    }
  }
`

/**
 * DETAIL QUERY
 * Fetches full info for editing
 */
export const DETAIL_QUERY = gql`
  query DepartmentDetail($id: MongoID!) {
    item: departmentById(_id: $id){
    _id
     name
     msSupervisorGroupID
     msUserGroupID
     isActive
     archived,
     path,
     organisation{
      _id
      name
    }
    company{
       _id
      name
    }
     address { 
      first
      second
      third
      fourth
      fifth
      sixth
     }
    invoiceCode
    }
  }
`

/**
 * CREATE MUTATION
 */
export const CREATE_MUTATION = gql`
  mutation DepartmentCreateOne($record: CreateOneDepartmentInput!) { 
    saveItem: departmentCreateOne(record: $record) { 
      recordId 
      record {    
        ${summaryReturnedFields}
      }  
    } 
  }`

/**
 * UPDATE MUTATION
 * Note: The returned fields should only include those managed by the department privilege.
 * Some fields such as Path, iden, should not be editable by department admins and thus are not returned here to avoid confusion.
 */
export const UPDATE_MUTATION = gql`
  mutation UpdateDepartment($filter: FilterUpdateOneDepartmentInput, $record: UpdateOneDepartmentInput!) {
    saveItem: departmentUpdateOne(filter: $filter, record: $record) {
      recordId
      record { 
        _id
        name
        msSupervisorGroupID
        msUserGroupID
        isActive
        archived,
        path,
        address { 
          first
          second
          third
          fourth
          fifth
          sixth
        }
        invoiceCode  
      }
    }
  }
`

/**
 * DELETE MUTATION
 */
export const DELETE_MUTATION = gql`
  mutation RemoveDepartments($id: MongoID!) {
    departmentRemoveById(_id: $id){
    recordId
    }
  }
`
